import React, { useEffect, useState } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import { pdfPageCss } from "../../util/pdf/pdfCssStyles";

const styles = StyleSheet.create(pdfPageCss);

export const LocationDescriptionPdf = ({
  latitude,
  longitude,
  placeName,
  buildingHeight,
  roofarea,
  groundLevel,
}) => {
  const { t } = useTranslation();

  const [address, setAddress] = useState();

  useEffect(() => {
    if (placeName && placeName.includes("Lat:") && placeName.includes("Lng:")) {
      setAddress(null);
    } else {
      setAddress(placeName);
    }
  }, [placeName]);

  return (
    <View style={styles.section}>
      {buildingHeight && (
        <Text style={styles.subTitle}>{`${t("policy.buildingHeight")}: ${buildingHeight} m`}</Text>
      )}
      <Text style={styles.subTitle}>{`${t("policy.roofArea")} : ${roofarea} m² `}</Text>
      <Text style={styles.subTitle}>{`${t("policy.heightFromSea")}: ${groundLevel} m `}</Text>
      <Text style={styles.subTitle}>{`${t("latitude")}: ${parseFloat(latitude).toFixed(5)}  `}</Text>
      <Text style={styles.subTitle}>{`${t("longitude")}: ${parseFloat(longitude).toFixed(5)}  `}</Text>
      {address && <Text style={styles.subTitle}>{`${t("address")}: ${address}`}</Text>}
    </View>
  );
};
